import { useEffect, useLayoutEffect, useRef } from 'react';

import { useBackHandlerStore } from '@/store/back-handler/back-handler.store';

export const useBackHandler = (handler?: () => void | Promise<void>): void => {
  const handlerRef = useRef(handler);
  useLayoutEffect(() => {
    handlerRef.current = handler;
  });

  const push = useBackHandlerStore((s) => s.push);
  const pop = useBackHandlerStore((s) => s.pop);

  const hasHandler = handler !== undefined;

  useEffect(() => {
    if (!hasHandler) return;
    const id = push(handlerRef);
    return () => pop(id);
  }, [hasHandler, push, pop]);
};
